import { render } from "./DoumiConfig.vue?vue&type=template&id=f4f200de"
import script from "./DoumiConfig.vue?vue&type=script&lang=js"
export * from "./DoumiConfig.vue?vue&type=script&lang=js"

import "./DoumiConfig.vue?vue&type=style&index=0&id=f4f200de&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__